angular.module('impactx.tender').controller('TenderLotCSCCtrl', [
    '$routeParams',
    'selectedListItems',
    TenderLotCSCCtrl
]);

function TenderLotCSCCtrl($routeParams, selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ViewTenderDetail'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/tender/templates/tenderlotcsclist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/tender/tenderlotcsc/list',
        id: "tenderlotcsclist",
        params: {
            id: $routeParams.id
        },
        valuesInteger: [{name: "tenderId", value: $routeParams.id}],
        idColumn: "cscId"
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        var selectedItem = selectedListItems.getFirstSelectedItem();
        var tenderId = selectedItem ? selectedItem.tenderId : $routeParams.id;
        return "tenderlotcscdetail/" + tenderId;

    }
}